import React, { useState, useEffect } from "react";
import Contact from "../components/Contact";
import { motion } from "framer-motion";
import { projects } from "../data/projects";
import { cloudinaryImage } from "../utils/cloudinary";
import { Link } from "react-router-dom";


export default function Home() {
  const heroSlides = [
    { src: "/main/main7.png", mobilePosition: "50% 32%" },
    { src: "/main/main1.jpg", mobilePosition: "52% 30%" },
    { src: "/main/main3.jpg", mobilePosition: "50% 36%" },
    { src: "/main/main2.jpg", mobilePosition: "50% 34%" },
  ];
  const [current, setCurrent] = useState(0);

  const featuredCategories = [
    { title: "מקלחונים", image: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769348055/IMG_4132_wl0sge.heic" },
    { title: "מראות", image: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769351983/IMG_3952_bqoeeh.heic" },
    { title: "מעקות", image: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769347939/IMG_0507_vcnvhs.jpg" },
    { title: "ויטרינות", image: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769352555/IMG_3720_vshcze.heic" },
  ];

  const featuredProjects = projects.slice(0, 2);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  return (
    <div className="min-h-screen">
      
      {/* --- Hero Section --- */}
      <section id="hero" className="relative w-full h-[84svh] md:h-screen overflow-hidden">

        {/* Images with Crossfade */}
        {heroSlides.map((slide, index) => (
          <React.Fragment key={slide.src}>
            <motion.img
              src={slide.src}
              alt="Moyal Glass"
              initial={{ opacity: 0 }}
              animate={{ opacity: index === current ? 1 : 0 }}
              transition={{ duration: 1.5, ease: "easeInOut" }}
              className="absolute inset-0 w-full h-full object-cover md:hidden"
              style={{
                zIndex: index === current ? 2 : 1,
                objectPosition: slide.mobilePosition,
              }}
            />

            <motion.img
              src={slide.src}
              alt="Moyal Glass"
              initial={{ opacity: 0 }}
              animate={{ opacity: index === current ? 1 : 0 }}
              transition={{ duration: 1.5, ease: "easeInOut" }}
              className="absolute inset-0 w-full h-full object-cover hidden md:block"
              style={{
                zIndex: index === current ? 2 : 1,
              }}
            />
          </React.Fragment>
        ))}

        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/75"></div>
        <div className="absolute inset-0 [background:radial-gradient(900px_circle_at_50%_20%,rgba(245,158,11,0.16),transparent_60%)]"></div>

        {/* Moving logo - animation runs once */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full select-none px-6">
          {/* Scrolling arrow */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 2 }}
            className="absolute bottom-10 text-white/80 hover:text-white animate-bounce cursor-pointer text-3xl"
            onClick={() => window.scrollTo({ top: window.innerHeight, behavior: "smooth" })}
          >
            ↓
          </motion.div>
        </div>
      </section>

      {/* --- Featured Categories Strip (4 cards) --- */}
      <section className="w-full py-6 md:py-10 px-6 md:px-8">
        <div className="max-w-6xl mx-auto" dir="rtl">
          <div className="flex items-end justify-between gap-6 mb-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-slate-100">
                קטגוריות נבחרות
              </h3>
              
            </div>
            <a href="/gallery" className="hidden md:inline-flex btn-secondary">
              לכל הגלריה
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {featuredCategories.map((c) => (
              <a
                key={c.title}
                href={`/gallery#${encodeURIComponent(c.title)}`}
                className="glass-card border-gradient animated hover-float glow overflow-hidden text-right relative group"
              >
                <div className="h-44 sm:h-48 lg:h-56 relative">
                  <img
                    src={cloudinaryImage(c.image)}
                    alt={c.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute top-4 right-4 backdrop-blur-md bg-slate-900/40 border border-slate-200/30 rounded-xl px-4 py-2 shadow-lg">
                    <h4 className="text-xl font-bold text-white drop-shadow-lg">{c.title}</h4>
                  </div>
                </div>
              </a>
            ))}
          </div>

          <div className="md:hidden mt-6 flex justify-center">
            <a href="/gallery" className="btn-secondary">
              לכל הגלריה
            </a>
          </div>
        </div>
      </section>

      {/* --- Featured Projects (2 cards) --- */}
      <section className="w-full py-10 md:py-14 px-6 md:px-8">
        <div className="max-w-6xl mx-auto" dir="rtl">
          <div className="flex items-end justify-between gap-6 mb-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-slate-100">
                פרויקטים נבחרים
              </h3>
            </div>
            <Link to="/projects" className="hidden md:inline-flex btn-secondary">
              לכל הפרויקטים
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
            {featuredProjects.map((p) => (
              <article key={p.id} className="group">
                <Link to={`/projects/${p.id}`} className="block">
                  <div className="relative overflow-hidden bg-black">
                    <img
                      src={cloudinaryImage(p.coverImage)}
                      alt={p.title}
                      className="w-full h-[360px] md:h-[420px] object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/18 opacity-100 group-hover:bg-black/6 transition" />
                  </div>

                  <div className="pt-5 text-center">
                    <h4 className="text-2xl md:text-3xl font-light text-slate-100 tracking-tight leading-tight">
                      {p.title}
                    </h4>
                    <p className="mt-1 text-base md:text-lg text-slate-400">
                      {p.location}
                    </p>
                    <span className="inline-block mt-3 text-sm md:text-base text-slate-200 border-b border-slate-500/70 pb-1">
                      לפרויקט מלא
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          <div className="md:hidden mt-6 flex justify-center">
            <Link to="/projects" className="btn-secondary">
              לכל הפרויקטים
            </Link>
          </div>
        </div>
      </section>

      {/* --- Contact Section with side photo --- */}
      <section id="contact-wrapper" className="w-full bg-transparent py-16 md:py-24 px-6 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="glass-card border-gradient animated overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-slate-700/60">
              {/* Left contact card */}
              <div className="p-7 md:p-10 flex justify-center items-center" dir="rtl">
                <div className="w-full max-w-[420px]">
                  <Contact />
                </div>
              </div>

              {/* Right content */}
              <motion.div
                initial={{ opacity: 0, x: 24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.6 }}
                className="p-7 md:p-10 text-right"
                dir="rtl"
              >
                <div className="mt-20 inline-flex items-center gap-2 pill px-4 py-2">
                  <span className="h-2 w-2 rounded-full bg-amber-500"></span>
                  דברו איתנו
                </div>
                <h3 className="mt-5 text-3xl md:text-4xl font-bold text-slate-100">
                 מויאל - עבודות זכוכית
                </h3>
                <p className="mt-3 text-2xl text-slate-300 leading-8">
                 עבודות זכוכית בהתאמה אישית.
                 
                </p>

                <p className="mt-6 text-slate-300 leading-8">
                  מתמחים בעבודות זכוכית בהתאמה אישית, ביצוע פרוייקטים בסטנדרט אדריכלי הכולל קוויים נקיים, עיצוב מינימליסטי ומודרני.
                </p>

                <div className="mt-8 space-y-3 text-slate-300 leading-8 text-sm">
                  <p>
                    ✓ עבודות זכוכית בהתאמה אישית
                  </p>
                  <p>
                    ✓ ביצוע פרויקטים בסטנדרט אדריכלי
                  </p>
                  <p>
                    ✓ קוויים נקיים, עיצוב מינימליסטי
                  </p>
                  <p>
                    ✓ שירות מקלחות, מראות, ויטרינות
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
